module.exports = __webpack_public_path__ + "img/product_accessory-2.d6dfa7c.png";